/* global gsap ScrollTrigger */
gsap.registerPlugin(ScrollTrigger);

const centerTargets = gsap.utils.toArray('[data-element="clip-center"]');

const mm = gsap.matchMedia();
const breakPoint = 800;

if (centerTargets && centerTargets.length > 0) {
  centerTargets.forEach((target) => {
    const trigger = target.closest('[data-element="clip-enter"]');

    mm.add(
      {
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint - 1}px)`,
      },
      (context) => {
        const {isDesktop} = context.conditions;

        gsap.to(target, {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: trigger,
            scrub: 1,
            start: isDesktop? 'top top': 'top center',
            end: isDesktop ? '125%' : 'top top',
            toggleActions: 'restart pause resume pause',
            pin: isDesktop ? true : false,
            refreshPriority: 1, // needed because we don't know what order these will be on the page
          },
          clipPath: 'inset(0.01% 0.02% 0% 0.04%)',
        });
      },
    );
  });
}

const leftTargets = gsap.utils.toArray('[data-element="clip-left"]');

if (leftTargets && leftTargets.length > 0) {
  leftTargets.forEach((target) => {
    const trigger = target.closest('[data-element="clip-enter"]');

    mm.add(
      {
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint - 1}px)`,
      },
      (context) => {
        const {isDesktop} = context.conditions;

        gsap.to(target, {
          scrollTrigger: {
            trigger: trigger,
            scrub: 1,
            start: isDesktop? 'top top': 'top center',
            end: isDesktop ? '125%' : 'top top',
            toggleActions: 'restart pause resume pause',
            pin: isDesktop ? true : false,
            refreshPriority: 1, // needed because we don't know what order these will be on the page
          },
          clipPath: 'inset(0.01% 0% 0.03% 0.04%)',
        });
      },
    );
  });
}
